import type { AuthKit } from "@peerup/auth-kit"
import type * as Sentry from "@sentry/vue"

import { SuiteAdapter } from "@peerup/suite/adapter"

import type { AliWebLogger } from "@/utils/logger"

import { envConfig, IS_DEV } from "./envsConfig"

export const isDev = envConfig.VITE_APP_ENV === "dev"

/**
 * 是否为内部测试环境
 */
export const isTest = ["dev", "sit", "sit1"].includes(envConfig.VITE_APP_ENV)

/**
 * 是否为线上环境
 */
export const isProd = !isTest

/**
 * 是否为调试模式
 */
export const isDebugger = () => {
  if (isProd) return false
  return !!window?.debugger || localStorage.getItem("debug")
}

/**
 * 调试模式
 */
export const inDebugMode = false

/**
 * 缓存优化开关
 */
export const withCache = !inDebugMode

/**
 * 调试环境
 */
export const isDevDebugMode = isTest || inDebugMode

const needLog = !window.location.href.includes("need-log=false")
/**
 * 是否启用日志
 */
export const allowLog = () => needLog && (envConfig.NEED_LOG && !window.location.pathname.startsWith("/snapshot/"))
/**
 * 前端应用版本号
 */
export const VITE_APP_VERSION = __VERSION__.split(/[\^:]/)[0]

export * from "./envsConfig"

export const isMicroApp = SuiteAdapter.isMicroApp()

/** 是否监控上报前端错误 */
export const ERROR_REPORT = needLog && !envConfig.SENTRY_DISABLE && !window.location.pathname.startsWith("/snapshot/") && !IS_DEV

/**
 * 获取全局数据（MainApp传入的）
 */
export const getGlobalData = () => SuiteAdapter.getGlobalData<{
  authKit: AuthKit
  logger: AliWebLogger
  getSentryInstance: () => ReturnType<typeof Sentry.init> | null
  getSentry: () => typeof Sentry
}>()

/**
 * Sentry DSN (基座应用和子应用的DSN不同)
 * 当当前是子应用时，且父应用提供了DSN时，使用父应用的DSN
 */
export const SENTRY_DSN = getGlobalData()?.getSentryInstance()?.getOptions()?.dsn
  || "https://d19434631fee735c024df25126fa4105@o4510032419684352.ingest.de.sentry.io/4510039134306384"
